module.exports = __webpack_public_path__ + "img/11.bac331ef.png";